export default "__VITE_ASSET__BVjaVsxX__"